import { createContext } from "react";
import WeekTimeCalendar from "./components/WeekTimeCalendar";

const CalendarContext = createContext(null);

const CalendarView = () => {
  return (
    <div className="w-full flex flex-col min-h-0">
      <WeekTimeCalendar />
    </div>
  );
};

export { CalendarContext };
export default CalendarView;
